/*
 * Copyright (c) 2014-2024 Comparatio USA  LLC. <https://www.comparatio.com>
 */

const tableCols = [
	{
		field : 'TRANSACTION_YEAR',
		header : 'Year',
		visible : true,
		filter : false,
		sort : true,
		tooltip : 'Transaction Year',
		export : { visible : false, checked : false },
		width : 50
	},
	{
        field: 'TRANSACTION_MONTH',
        header: 'Month',
        visible: true,
        filter: false,
        sort: false,
        tooltip: 'Transaction Month',
        export: {visible: false, checked: false},
        width: 100
    },
    {
        field: 'TRANSACTION_COUNT',
        header: 'Transactions',
        visible: true,
        filter: false,
        sort: true,
        tooltip: 'Transaction Count (each).',
        export: {visible: false, checked: false},
        width: 50
    },
    {
        field: 'AVG_TRANSACTION_IMPORT_TIME',
        header: 'Import Time',
        visible: true,
        filter: false,
        sort: true,
        tooltip: 'Average Transaction Import Time (seconds).',
        export: {visible: false, checked: false},
        width: 50
    },
    {
        field: 'ORDER_CAPACITY',
        header: 'Order Capacity',
        visible: true,
        filter: false,
        sort: true,
        tooltip: 'Order Capacity (each).',
        export: {visible: false, checked: false},
        width: 50
    }
];
export default tableCols;



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/transaction-reports/transaction-duration-report-capacity/transaction-duration-report-capacity.cols.ts